<template>
    <div id="notifications-container">
        <v-snackbar @input="notificationChanged(notification)" v-model="notification.show"
            :timeout="notification.timeout || 2000" v-for="notification in sysNotifications" :key="notification.id">
            {{ notification.text }}

            <v-btn color="primary" text @click="invoke(notification)">
                {{ notification.btn_label || "dismiss" }}
                <v-icon v-if="notification.btn_icon" right>{{ notification.btn_icon }}</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    import {
        mapActions,
        mapGetters
    } from "vuex";

    export default {
        name: "SysNotifications",

        computed: {
            ...mapGetters("appshell", ["sysNotifications"]),
        },

        methods: {
            notificationChanged(obj) {
                if (!obj.show && obj.auto_dismiss) this.$store.commit("appshell/removeNotification", obj.id);
            },
            invoke(noti) {
                if (noti.btn_click && typeof(noti.btn_click) == "function") {
                    noti.btn_click();
                }
                this.$store.commit("appshell/removeNotification", noti.id);
            }
        },

        data: () => ({

        }),
    }
</script>

<style lang="scss" scoped>
    #notifications-container {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: center;
    }
</style>